"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTimezoneItemDto = instanceOfTimezoneItemDto;
exports.TimezoneItemDtoFromJSON = TimezoneItemDtoFromJSON;
exports.TimezoneItemDtoFromJSONTyped = TimezoneItemDtoFromJSONTyped;
exports.TimezoneItemDtoToJSON = TimezoneItemDtoToJSON;
exports.TimezoneItemDtoToJSONTyped = TimezoneItemDtoToJSONTyped;
/**
 * Check if a given object implements the TimezoneItemDto interface.
 */
function instanceOfTimezoneItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('iana' in value) || value['iana'] === undefined)
        return false;
    if (!('displayName' in value) || value['displayName'] === undefined)
        return false;
    if (!('offsetLabel' in value) || value['offsetLabel'] === undefined)
        return false;
    if (!('observesDst' in value) || value['observesDst'] === undefined)
        return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined)
        return false;
    return true;
}
function TimezoneItemDtoFromJSON(json) {
    return TimezoneItemDtoFromJSONTyped(json, false);
}
function TimezoneItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'iana': json['iana'],
        'displayName': json['displayName'],
        'offsetLabel': json['offsetLabel'],
        'observesDst': json['observesDst'],
        'isDefault': json['isDefault'],
    };
}
function TimezoneItemDtoToJSON(json) {
    return TimezoneItemDtoToJSONTyped(json, false);
}
function TimezoneItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'iana': value['iana'],
        'displayName': value['displayName'],
        'offsetLabel': value['offsetLabel'],
        'observesDst': value['observesDst'],
        'isDefault': value['isDefault'],
    };
}
